import styled from 'styled-components';
import { useGetFilterHasSelectedOption } from '../../../../hooks/filter/useGetFilterHasSelectedOption';

export const EmptySpace = () => {
  const { isFilterHasSelectedOption } = useGetFilterHasSelectedOption({ filter: 'all' });

  // 선택된 필터가 있을 때, 상단 영역의 크기가 증가됨. 이에 같은 크기만큼 본문의 margin-top 을 적용하기 위해 구현함
  return <Div isFilterHasSelectedOption={isFilterHasSelectedOption} />;
};

const Div = styled.div<{ isFilterHasSelectedOption: boolean }>`
  margin-top: ${(props) => (props.isFilterHasSelectedOption ? '44px' : '0px')};
`;
